import Cookies from 'js-cookie';
import { useEffect } from 'react';

const ATTRIBUTE_THEME_NAME = 'data-theme';

export function DarkmodeHelper() {
	const theme = Cookies.get(ATTRIBUTE_THEME_NAME);
	const elementTheme =
		document.documentElement.getAttribute(ATTRIBUTE_THEME_NAME);

	useEffect(() => {
		if (theme) {
			document.documentElement.setAttribute(ATTRIBUTE_THEME_NAME, theme);
		}
	}, [theme, elementTheme]);

	return null;
}
